document.addEventListener('DOMContentLoaded', function () {
  // -- Notyf --------
  function initNotyf() {
    window.notyf = new Notyf({
      types: [{ type: 'success', background: '#009f7d' }]
    });
  }

	// Start
  initNotyf();
});
